import React, { ReactEventHandler, VFC } from 'react';
import styled from 'styled-components';
import { useTheme, makeStyles, Theme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';

import PCHeaderContent from '../organisms/PCHeaderContent';
import SPHeaderContent from '../organisms/SPHeaderContent';
// js codes
import { getMinHeight } from '../utils';
import SubHeader from '../molecules/SubHeader';

const SubHeaderWrapper = styled.div<{ theme: Theme }>`
  border-top: 1px solid ${({ theme }) => theme.palette.primary.main};
`;

const useStyles = makeStyles((theme: Theme) => ({
  appBarRoot: {
    backgroundColor: theme.palette.common.white,
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    zIndex: 1203,

    [theme.breakpoints.up('md')]: {
      borderBottom: 'none',
    },
  },
  toolbarRoot: {
    maxWidth: theme.breakpoints.values.lg,
    width: '100%',
    margin: 'auto',

    [theme.breakpoints.up('md')]: {
      minHeight: getMinHeight(theme),
    },
  },
}));

interface Props {
  isPC: boolean;
  authenticated: boolean;
  spDrawerOpen: boolean;
  imageUrl?: string | null;
  profileMenuEl: Element | null;
  handleOpenSPDrawer: ReactEventHandler;
  handleCloseSPDrawer: ReactEventHandler;
  handleClickSPDrawer: ReactEventHandler;
  handleOpenSearchDrawer: () => void;
  handleOpenProfileMenu: (anchorEl: Element | null) => void;
}
const HeaderComponent: VFC<Props> = ({
  isPC,
  authenticated,
  spDrawerOpen,
  imageUrl,
  profileMenuEl,
  handleOpenSPDrawer,
  handleCloseSPDrawer,
  handleClickSPDrawer,
  handleOpenSearchDrawer,
  handleOpenProfileMenu,
}: Props) => {
  const theme = useTheme();
  const { appBarRoot, toolbarRoot } = useStyles();

  return (
    <AppBar elevation={0} classes={{ root: appBarRoot }}>
      <Toolbar classes={{ root: toolbarRoot }}>
        {isPC ? (
          <PCHeaderContent
            authenticated={authenticated}
            imageUrl={imageUrl}
            profileMenuEl={profileMenuEl}
            handleOpenSearchDrawer={handleOpenSearchDrawer}
            handleOpenProfileMenu={handleOpenProfileMenu}
          />
        ) : (
          <SPHeaderContent
            authenticated={authenticated}
            spDrawerOpen={spDrawerOpen}
            imageUrl={imageUrl}
            profileMenuEl={profileMenuEl}
            handleOpenSPDrawer={handleOpenSPDrawer}
            handleCloseSPDrawer={handleCloseSPDrawer}
            handleClickSPDrawer={handleClickSPDrawer}
            handleOpenSearchDrawer={handleOpenSearchDrawer}
            handleOpenProfileMenu={handleOpenProfileMenu}
          />
        )}
      </Toolbar>

      {/* PCHeaderComponentに近いところで定義したい */}
      {isPC && (
        <SubHeaderWrapper theme={theme}>
          <SubHeader />
        </SubHeaderWrapper>
      )}
    </AppBar>
  );
};

export default HeaderComponent;
